// src/config.js
const CONFIG = {
     API_URL: 'https://azure-webapp-backend-muzeu-v2.sci-web.ro/api',
     STRAPI_TOKEN: '2aa74dff7d095f925adbf728a9b59c5bdf2a5cd8a49fbd6f4b932d41205c6c28809537a7125545e0167354c0dba51ae0da9a91202636323de6f3258e1de8c51571b5394ac59cf6c4654013fdaf0fa5dc3c01bcab1ad05724a690f48e6cac28c0bbb2df51e5bad7856ee54bd76668937535bc5e2b269afaa3e0624c89d9383ade', // Add your API Token here
};

export default CONFIG;
